<nav class="pagination">
  <button (click)="prevPage.emit()" [disabled]="!hasPreviousPage()" [class.disabled]="!hasPreviousPage()">
    <svg-icon src="assets/images/icons/chevron-down.svg"></svg-icon>
  </button>
  <button (click)="nextPage.emit()" [disabled]="!hasNextPage()" [class.disabled]="!hasNextPage()">
    <svg-icon src="assets/images/icons/chevron-down.svg"></svg-icon>
  </button>
</nav>
